module.exports = __webpack_public_path__ + "static/media/clock.cd2cc31b.svg";